<template>
    <div class="ht333First">        
        <div class="ht333First-title" v-html="$t('hiteach333_text1')"></div>
        <div class="ht333First-cont" v-html="$t('ht333first_text8')"></div>
        <div class="ht333First-cont">
            <img style="width: 100%;" :src="ht333_introduce_src" />
        </div>
        <div style="text-align: center;" v-if="tokens.id_token == ''">
            <n-button type="info" @click="loginAccoount()">{{ $t('ht333first_text12') }}</n-button>
        </div>
        <template v-else>
            <template v-if="!isFinsh">
                <div class="ht333First-cont" v-html="$t('ht333first_text1')"></div>
                <base-ex ref="baseEXE" class="ht333First-form" :key="refreshKey"></base-ex>
                <div style="display: flex;justify-content: space-evenly;">
                    <n-button type="info" @click="validForm()" :disabled="!isFormFinsh">{{ $t('ht333first_text2') }}</n-button>
                    <n-button type="default" @click="logOut()">{{ $t('ht333first_text13') }}</n-button>
                </div>
            </template>            
            <template v-else>
                <div class="event3 scrollstyle" id="event3">
                    <div class="event3-step">
                        <div class="stepFinshFrame">
                            <div class="cont" :class="{'en': lang =='en'}">
                                {{ $t('hiteach333_finsh') }}
                            </div>
                        </div>
                        <div class="event3-step-title">
                            {{ $t('hiteach333_text3') }}
                        </div>
                        <div class="event3-step-subTitle">
                            － {{ $t('ht333first_text3') }}
                        </div>
                    </div>
                    <div class="event3-arrow">
                        <n-icon size="25" color="#333" :component="ChevronDown"/>
                    </div>
                    <div class="event3-step">
                        <div v-if="isStage2Finish" class="stepFinshFrame">
                            <div class="cont" :class="{'en': lang =='en'}">
                                {{ $t('hiteach333_finsh') }}
                            </div>
                        </div>
                        <div style="display: flex;align-items: center;justify-content: space-between;">
                            <div>
                                <div class="event3-step-title">
                                    {{ $t('hiteach333_text6') }}
                                    <n-icon style="margin-left: 5px;" size="23" color="#2196F3" :component="InformationCircleOutline"/>
                                </div>
                                <div class="event3-step-subTitle">
                                    － {{ $t('ht333first_text4') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="event3-arrow">
                        <n-icon size="25" color="#333" :component="ChevronDown"/>
                    </div>
                    <div class="event3-step">
                        <div v-if="isStage3Finish" class="stepFinshFrame">
                            <div class="cont" :class="{'en': lang =='en'}">
                                {{ $t('hiteach333_finsh') }}
                            </div>
                        </div>
                        <div class="event3-step-title">
                            {{ $t('hiteach333_text9')}}
                        </div>
                        <div class="event3-step-subTitle">
                            － {{ $t('ht333first_text4') }}
                        </div>
                    </div>
                    <div style="text-align: center;font-size: 20px;margin: 45px 0 12px 0;font-family: Verdana;">
                        {{ $t('ht333first_text9') }}
                    </div>
                    <div class="qrcodes">
                        <div class="qrcode">
                            <img :src="qrcode_i_appstore">
                            <div>{{ $t('ht333first_text5') }}</div>
                        </div>
                        <div class="qrcode">
                            <img :src="qrcode_a_googlplay">
                            <div>{{ $t('ht333first_text6') }}</div>
                        </div>
                        <div class="qrcode">
                            <img :src="qrcode_a_d_apk">
                            <div>{{ $t('ht333first_text7') }}</div>
                        </div>
                    </div>
                    <div class="event3-remark">
                        <ul>
                            <li>{{ $t('hiteach333_text12')}}</li>
                            <li>{{ $t('hiteach333_text13')}}</li>
                            <li v-html="$t('hiteach333_text14')"></li>
                            <li v-html="$t('ht333first_text10')"></li>
                            <li v-html="$t('ht333first_text11')"></li>
                        </ul>
                    </div>
                </div>
                <div style="text-align: center;">
                    <n-button type="info" @click="logOut()">{{ $t('ht333first_text13') }}</n-button>
                </div>
            </template>
        </template>
    </div>
</template>

<script>
import { defineComponent, onMounted, ref, computed, inject } from 'vue'
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { jsFn } from "@/utils/jsFn";
import { useStore } from "vuex";
import baseex from '@/components/baseEX.vue'
import { ChevronDown } from '@vicons/ionicons5'
import naiveFnc from "@/utils/naiveFnc";

export default defineComponent({
    components: {
        'base-ex': baseex
    },
    setup() {
        const { crtDialog } = naiveFnc();
        const changeSpinState = inject('changeSpinState')
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const i18n = useI18n();
        const { t } = i18n;
        const baseEXE = ref()
        const baseEXCheckKey = computed(() => store.getters["coreApi/baseEXCheckKey"]);
        const baseEx = computed(() => store.getters['coreApi/baseEx']);
        const events = computed(() => store.getters["coreApi/events"]);
        const isEventSuccess = ref(false)
        const isFinsh = ref(false)
        const isStage2Finish = ref(false)
        const isStage3Finish = ref(false)
        const refreshKey = ref(0)
        const coupons = computed(() => store.getters["coreApi/coupons"]);
        const HT333Coupon = computed(() => store.getters['coreApi/getEvCoupon']('HITEACH50'))
        const tokens = computed(() => store.getters["coreApi/tokens"]);

        // 圖檔設定
        var qrcode_a_d_apk = require("@/assets/img/qrcode_android_download_apk.png");
        var qrcode_a_googlplay = require("@/assets/img/qrcode_android_googleplay.png");
        var qrcode_i_appstore = require("@/assets/img/qrcode_ios_appstore.png");
        var ht333_introduce_tw = require("@/assets/img/ht333_introduce_tw.png");
        var ht333_introduce_cn = require("@/assets/img/ht333_introduce_cn.png");
        var ht333_introduce_en = require("@/assets/img/ht333_introduce_en.png");
        var ht333_introduce_src = ht333_introduce_en

        // 抓取瀏覽器的語系
        var lang = 'en' // 預設英文
        let webLang = navigator.language.toLowerCase()
        switch(webLang) {
            case'zh-tw':
                lang = 'tw'
                ht333_introduce_src = ht333_introduce_tw
            break
            case'zh-cn':
                lang = 'cn'
                ht333_introduce_src = ht333_introduce_cn
            break
            case 'ja-jp':
                lang = 'jp'
            break;
        }

        // 設定頁面的語系
        i18n.locale.value = lang;
        localStorage.setItem("lang", lang);

        // 設定都完成按鈕亮燈
        const isFormFinsh = computed(()=>{
            let flag = true
            baseEXCheckKey.value.forEach(c=>{
                switch(c){
                    case 'schoolCode':
                        // 暫不檢查
                        // if(baseEXE.value?.baseExValue['country'] == 'TW' && (baseEXE.value?.baseExValue[c] == '' || baseEXE.value?.baseExValue[c] == null)){
                        //     flag = false
                        // }
                    break
                    default:
                        if(baseEXE.value?.baseExValue[c] == '' || baseEXE.value?.baseExValue[c] == null) {
                            flag = false
                        }
                }
            })
            return flag
        })  

        const loginAccoount = ()=>{
            if(jsFn.isCN()) {
                location.href = `https://account.teammodel.cn?callback=${location.href}`
            } else {
                location.href = `https://account.teammodel.net?callback=${location.href}`
            }            
        }

        const logOut = () => {
            localStorage.clear()
            location.reload()
        }

        // 欄位檢查
        const validForm = ()=>{
            baseEXE.value.baseExFormRef.validate(
                async(errors) => {
                    if (!errors) {
                        changeSpinState() // 開啟全屏spin
                        let data = {}
                        if(baseEx.value){
                            let bKeys = Object.keys(baseEx.value)

                            bKeys.forEach(k=>{
                                if(baseEXE.value.baseExValue[k]) {
                                    data[k] = baseEXE.value.baseExValue[k]
                                } else {
                                    data[k] = baseEx.value[k]
                                }
                            })
                        } else {
                            data = baseEXE.value.baseExValue
                        }

                        // 寫入baseEX
                        await store.dispatch('coreApi/setUserContact', data)

                        // 申請加入學校
                        if(data['schoolCode']) {
                            await store.dispatch("ies5Api/applySchool", data['schoolCode'])
                            await store.dispatch("sokplatformApi/applyChannel", data['schoolCode'])
                        }

                        // 兌換333
                        await exchangeHT333(HT333Coupon.value).then(res=>{
                            if(res) {
                                isFinsh.value = true
                            }
                            changeSpinState() // 關閉全屏spin
                        })
                    }
                }
            )
        }

        async function exchangeHT333(coupon){
            let res = await getCoupon(coupon.code)
            if(res.state > 0){
                crtDialog(t('notice'), res.msg)
                return false
            } else {
                let eRes = await exchangeVoucher(res.data.voucher)
                if(eRes.state > 0){
                    crtDialog(t('notice'), eRes.msg)
                    return false
                } else {
                    let result = res.data
                    let eventName = ''
                    if(result.eventName != null && typeof result.eventName != 'undefined') {
                        let eventTemp = result.eventName.split('-')
                        eventName = eventTemp[0].toLocaleLowerCase()
                    }

                    // 活動券設定
                    await store.dispatch("coreApi/setUserEvents", {name: eventName, step: 1, done: new Date().getTime()})

                    // 優惠券設定
                    let temp = coupons.value.filter( y => y.code == coupon.code)

                    if(temp.length > 0){
                        coupon.isExchange = true
                        coupon.endTime = new Date().getTime()

                        store.dispatch('coreApi/updUserCoupons', coupon)
                    } else {
                        let ticket = {
                            type: coupon.type,
                            code: coupon.code,   // 兌換卷號
                            info: [], 
                            expire: result.expire, // 到期日
                            isExchange: true,// 是否被兌換
                            isExpired: false, // 是否已過期
                            endTime: new Date().getTime(),      // 結束時間(包含兌換與過期時間，預計保留半年)
                            eventName: eventName
                        }

                        if(result.info) {
                            ticket.info = JSON.parse(result.info)
                        }

                        if(ticket.info.length == 0){
                            if(coupon.title) ticket.title = coupon.title
                            if(coupon.cont) ticket.cont = coupon.cont
                        }

                        store.dispatch('coreApi/setUserCoupons', ticket)
                    }
                
                    await store.dispatch("coreApi/setUsersetting") // 儲存現在的usersetting
                    await store.dispatch("coreApi/getUsersetting", 'mynews') //取得個人在mynews的設定檔

                    return true
                }
            }            
        }

        // 取得voucher
        async function getCoupon(code){
            let errStr = ''
            let data = {}
            await store.dispatch('coreApi/getCoupon', code).then( res => {
                if(res.error) {
                    let error = res.error.toString()
                    switch(error) {
                        case '9':
                            errStr = t('error_9')
                        break
                        case '14':
                            errStr = t('error_10')
                        break
                        case '15':
                            errStr = t('error_11')
                        break
                        case '20':
                            errStr = t('error_12')
                        break
                    }
                } else {
                    data = res
                }
            }).catch( () =>{
                errStr = t('error_3')
            })

            if(errStr != ''){
                return {state: 1, msg: errStr}
            } else {
                return {state: 0, data: data}
            }
        }

        // 兌換voucher
        async function exchangeVoucher(voucher){
            let errStr = ''
            await store.dispatch('coreApi/exchangeVoucher', voucher).then( res => {
                if(res.error) {
                    let error = res.error.toString()
                    switch(error) {
                        // case '8':
                        //   errStr = '票卷已過期'
                        // break
                        // case '9':
                        //   errStr = '你已使用過該票券'
                        // break
                        // case '12':
                        //     errStr = '活動尚未開始'
                        // break
                        // case '16':
                        //     errStr = '降規格(權益折損)'
                        // break
                        default:
                        errStr = t('error_10')
                    }
                }
            }).catch( () =>{
                errStr = t('error_3')
            })

            if(errStr != ''){
                return {state: 1, msg: errStr}
            } else {
                return {state: 0, msg: ''}
            }
        }

        // USER 快速登入
        onMounted(async() => {
            if (!jsFn.IsEmpty(route.query.ticket) || !jsFn.IsEmpty(route.query.code)) {
                changeSpinState() // 全屏spin

                let code = route.query.ticket ? route.query.ticket : route.query.code ? route.query.code : ''

                // 先重置
                await store.dispatch("coreApi/resetState")

                var res = await store.dispatch("coreApi/codeLogin", code)
                if (res) {
                    // 登入成功
                    //取得個人在base-ex的設定檔
                    await store.dispatch("coreApi/getUsersetting", 'base-ex')

                    //取得個人在mynews的設定檔
                    await store.dispatch("coreApi/getUsersetting", 'mynews')

                    refreshKey.value += 1

                    router.push({ name: 'ht333' })
                }
                changeSpinState() // 全屏spin                
            }

            // 檢查是否參加過活動(50 333擇一)
            let temp = events.value.filter( y => {
                return (y.name.toLocaleLowerCase() == 'hiteach333' || y.name.toLocaleLowerCase() == 'hiteach50')
            })

            // 大於0代表已參加過活動
            if(temp.length > 0){
                isEventSuccess.value = true
                isFinsh.value = true

                if(events.value){                    
                    events.value.forEach(x => {
                        if(x.name == 'hiteach333' || x.name == 'hiteach50') {
                            x.steps.forEach( y => {
                                switch (y.step){
                                    case 2:
                                        if(y.done != -1) isStage2Finish.value = true
                                    break
                                    case 3:
                                        if(y.done != -1) isStage3Finish.value = true
                                    break
                                }
                            })
                        }
                    })
                }
            } else {
                console.log('沒參加過活動')
            }

        });

        return {
            baseEXE,
            isFormFinsh,
            validForm,
            isEventSuccess,
            isFinsh,
            ChevronDown,
            refreshKey,
            isStage2Finish,
            isStage3Finish,
            qrcode_a_d_apk,
            qrcode_a_googlplay,
            qrcode_i_appstore,
            ht333_introduce_src,
            tokens,
            loginAccoount,
            logOut
        }
    }
})
</script>

<style  lang="less" scoped>
.ht333First{
    padding: 20px 20px 10px 20px;
    white-space: pre-line;
    &-title{
        color: #2196f3;
        font-size: 25px;
        font-weight: bold;
        margin-bottom: 30px;
        text-align: center;
        font-family: Comic Sans MS;
    }
    &-cont{
        padding: 0 50px;
        font-size: 16px;
        margin-bottom: 25px;
        font-family: Verdana;
    }
    &-form{
        padding: 0 50px;
    }
    .event3 {
        white-space: pre-line;
        position: relative;
        padding: 0 50px;
        font-family: Verdana;
        &-step{
            border: 2px solid #333;
            border-radius: 6px;
            padding: 9px 12px;
            margin-bottom: 7px;
            position: relative;
            &-title{
                font-size: 17px;
                display: flex;
                align-items: center;
                font-weight: bold;
            }
            &-subTitle{
                font-size: 20px;
                display: flex;
                align-items: center;
                color: #2196f3;
            }
            &-subCont{
                font-size: 14px;
                color: #757575;
                border-top: 1px dashed #333;
                margin-top: 15px;
                padding-top: 6px;
            }
            .stepFinshFrame{
                border: 4px solid rgb(230, 74, 25);
                padding: 7px;
                border-radius: 50%;
                color: rgb(230, 74, 25);
                position: absolute;
                right: 0px;
                // top: calc(50% - 42px);
                top: -3px;
                width: 60px;
                height: 60px;
                display: flex;
                justify-content: center;
                align-items: center;
                .cont{
                    display: flex;
                    font-size: 20px;
                    line-height: 1;
                    width: 50px;
                    height: 50px;
                    align-items: center;
                    justify-content: center;
                    transform: rotate(-20deg);
                    border: 1px solid rgb(230, 74, 25);
                    padding: 7px;
                    border-radius: 50%;
                    color: rgb(230, 74, 25);
                    position: absolute;
                    text-align: center;
                    &.en{
                        font-size: 17px;
                    }
                }
            }
        }
        &-arrow{
            display: flex;
            justify-content: center;
            margin-top: 5px;
        }
        &-remark{
            margin-top: 20px;
            ul{
                font-size: 14px;
                padding-left: 20px;
            }
        }
        .qrcodes{
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            align-items: center;
            .qrcode{
                text-align: center;
                img{
                    width: 170px;
                }
                // margin-bottom: 30px;
            }
        }
    }
}
</style>
